import { useState, useEffect } from "react";
import useAuth from "./useAuth";
import { STOCKITEMS_BASE_URL } from "../config";
import API from "../API";

const initialState = {
  additions: [],
  page: 0,
  total_pages: 0,
  total_results: 0,
};

export const useAdditionsListFetch = () => {
  const auth = useAuth();
  const [additionstate, setState] = useState(initialState);
  const [additionsearchValue, additionsetSearchValue] = useState("");
  const [includeInactive, setIncludeInactive] = useState(false);
  const [payrateloading, setLoading] = useState(false);
  const [payrateerror, setError] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const [firstLoad, setFirstLoad] = useState(true); // ✅ Prevent double fetching

  const accessToken = auth.auth.accessToken;

  const fetchAdditionsList = async (page, searchValue, reset = false) => {
    if (!hasMore && !reset) return; // Stop fetching if no more pages

    try {
      setLoading(true);
      setError(false);

      console.log(reset)

      const data = await API.fetchAdditions(searchValue, page, includeInactive, "", accessToken);
        
      console.log(data)
      setState((prev) => ({
        ...prev,
        additions: reset ? data.additions : data.additions, // ✅ Only reset on filter/search change
        page: page + 1,
        total_pages: data.total_pages,
        total_results: data.total_results,
      }));

      setHasMore(data.additions.length > 0);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching stock items:", error);
      setError(true);
    }
  };

  useEffect(() => {
    if (firstLoad) {
      setFirstLoad(false);
      fetchAdditionsList(1, additionsearchValue, true);
    }
  }, [firstLoad]); // ✅ Runs only once when the component mounts

  useEffect(() => {
    fetchAdditionsList(1, additionsearchValue, true); // ✅ Fetch when search/filter changes
  }, [additionsearchValue, includeInactive]);

  return { additionstate, payrateloading, payrateerror,additionsearchValue, additionsetSearchValue, setIncludeInactive, fetchAdditionsList };
};
